export const CREATE = 'CREATE'
export const DELETE = 'DELETE'
export const UPDATE = 'UPDATE'
export const FETCH_ALL = 'FETCH_ALL'
export const FETCH_BY_SEARCH = 'FETCH_BY_SEARCH'
export const FETCH_BY_CATEGORY = 'FETCH_BY_CATEGORY'
export const START_LOADING = 'START_LOADING'
export const END_LOADING = 'END_LOADING'
export const LIKE = 'LIKE';
export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const FETCH_ARTICLE = 'FETCH_ARTICLE';
export const COMMENT = 'COMMENT';
export const ADD_BOOKMARK = 'ADD_BOOKMARK';